import { useEffect, useState } from 'react';
import { auth } from './firebase';
import { 
  verifyPasswordResetCode, 
  confirmPasswordReset,
  applyActionCode 
} from 'firebase/auth';

export default function AuthAction() {
  // URL Params manuell lesen (kein React Router nötig)
  const params = new URLSearchParams(window.location.search);
  const mode = params.get('mode');
  const oobCode = params.get('oobCode');
  
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!oobCode || !mode) {
      setError('Invalid link');
      setLoading(false);
      return;
    }
    
    if (mode === 'resetPassword') {
      verifyPasswordResetCode(auth, oobCode)
        .then((email) => {
          setEmail(email);
          setLoading(false);
        })
        .catch((error) => {
          console.error('Verify error:', error);
          setError('Invalid or expired reset link');
          setLoading(false);
        });
    } else if (mode === 'verifyEmail') {
      applyActionCode(auth, oobCode)
        .then(() => {
          setSuccess(true);
          setLoading(false);
          setTimeout(() => {
            window.location.href = '/';
          }, 3000);
        })
        .catch((error) => {
          setError('Verification failed');
          setLoading(false);
        });
    }
  }, [oobCode, mode]);

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    setError('');

    if (newPassword.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    try {
      await confirmPasswordReset(auth, oobCode, newPassword);
      setSuccess(true);
      
      setTimeout(() => {
        window.location.href = '/';
      }, 3000);
      
    } catch (error) {
      console.error('Reset error:', error);
      setError('Failed to reset password');
    }
  };

  if (loading) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <div style={styles.spinner}></div>
          <p style={{ color: 'white' }}>Loading...</p>
        </div>
      </div>
    );
  }

  if (mode === 'resetPassword') {
    if (success) {
      return (
        <div style={styles.container}>
          <div style={styles.card}>
            <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>✅</div>
            <h2 style={{ color: 'white', marginBottom: '0.5rem' }}>Success!</h2>
            <p style={{ color: '#9ca3af' }}>Password has been reset.</p>
            <p style={{ color: '#9ca3af', fontSize: '0.875rem', marginTop: '1rem' }}>
              Redirecting to login...
            </p>
          </div>
        </div>
      );
    }

    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <h2 style={{ color: 'white', marginBottom: '0.5rem' }}>Reset Password</h2>
          <p style={{ color: '#9ca3af', marginBottom: '2rem', fontSize: '0.875rem' }}>
            For: {email}
          </p>

          <form onSubmit={handlePasswordReset}>
            <div style={{ marginBottom: '1rem' }}>
              <label style={styles.label}>New Password</label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Enter new password"
                style={styles.input}
                required
                minLength={6}
              />
            </div>

            <div style={{ marginBottom: '1rem' }}>
              <label style={styles.label}>Confirm Password</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirm new password"
                style={styles.input}
                required
                minLength={6}
              />
            </div>

            {error && (
              <div style={styles.error}>{error}</div>
            )}

            <button type="submit" style={styles.button}>
              Reset Password
            </button>
          </form>
        </div>
      </div>
    );
  }

  if (mode === 'verifyEmail' && success) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>✅</div>
          <h2 style={{ color: 'white' }}>Email Verified!</h2>
          <p style={{ color: '#9ca3af' }}>Redirecting...</p>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>❌</div>
        <h2 style={{ color: 'white' }}>Invalid Link</h2>
        <p style={{ color: '#9ca3af' }}>{error || 'Link is invalid or expired.'}</p>
        <button 
          onClick={() => window.location.href = '/'}
          style={styles.button}
        >
          Back to Home
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#111827',
    padding: '1rem',
  },
  card: {
    backgroundColor: '#1f2937',
    borderRadius: '0.5rem',
    padding: '2rem',
    maxWidth: '400px',
    width: '100%',
    textAlign: 'center',
  },
  label: {
    display: 'block',
    fontSize: '0.875rem',
    color: '#9ca3af',
    marginBottom: '0.5rem',
    textAlign: 'left',
  },
  input: {
    width: '100%',
    padding: '0.75rem',
    backgroundColor: '#374151',
    border: 'none',
    borderRadius: '0.5rem',
    color: 'white',
    fontSize: '1rem',
    boxSizing: 'border-box',
  },
  button: {
    width: '100%',
    padding: '0.75rem',
    backgroundColor: '#5e35b1',
    color: 'white',
    border: 'none',
    borderRadius: '0.5rem',
    fontSize: '1rem',
    cursor: 'pointer',
    marginTop: '1rem',
  },
  error: {
    backgroundColor: 'rgba(239, 68, 68, 0.1)',
    border: '1px solid #ef4444',
    borderRadius: '0.5rem',
    padding: '0.75rem',
    marginBottom: '1rem',
    fontSize: '0.875rem',
    color: '#fca5a5',
  },
  spinner: {
    width: '40px',
    height: '40px',
    margin: '0 auto 1rem',
    border: '4px solid #374151',
    borderTop: '4px solid #5e35b1',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
};